module.exports = __webpack_public_path__ + "static/img/icon.abb97d8c.png";